export default "assets/images/accordsparfait-511a6e01.png";